var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.reviews
    ? _c(
        "div",
        {
          staticClass: "bars-wrapper",
          class: "x" + (_vm.reviews.userScore + "").length,
        },
        [
          _c("span", { staticClass: "bar-c" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("span", { staticClass: "bar-b" }, [
              _vm.dataLoaded
                ? _c("span", {
                    staticClass: "bar",
                    style:
                      "width:" +
                      (_vm.reviews.stars[5] / _vm.reviews.userScore) * 100 +
                      "%",
                  })
                : _c("span", {
                    staticClass: "bar",
                    staticStyle: { width: "0%" },
                  }),
            ]),
            _vm._v(" "),
            _vm.dataLoaded
              ? _c("span", { staticClass: "txt" }, [
                  _vm._v("(" + _vm._s(_vm.reviews.stars[5]) + ")"),
                ])
              : _c("span", { staticClass: "txt" }, [_vm._v("(...)")]),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "bar-c" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("span", { staticClass: "bar-b" }, [
              _vm.dataLoaded
                ? _c("span", {
                    staticClass: "bar",
                    style:
                      "width:" +
                      (_vm.reviews.stars[4] / _vm.reviews.userScore) * 100 +
                      "%",
                  })
                : _c("span", {
                    staticClass: "bar",
                    staticStyle: { width: "0%" },
                  }),
            ]),
            _vm._v(" "),
            _vm.dataLoaded
              ? _c("span", { staticClass: "txt" }, [
                  _vm._v("(" + _vm._s(_vm.reviews.stars[4]) + ")"),
                ])
              : _c("span", { staticClass: "txt" }, [_vm._v("(...)")]),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "bar-c" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("span", { staticClass: "bar-b" }, [
              _vm.dataLoaded
                ? _c("span", {
                    staticClass: "bar",
                    style:
                      "width:" +
                      (_vm.reviews.stars[3] / _vm.reviews.userScore) * 100 +
                      "%",
                  })
                : _c("span", {
                    staticClass: "bar",
                    staticStyle: { width: "0%" },
                  }),
            ]),
            _vm._v(" "),
            _vm.dataLoaded
              ? _c("span", { staticClass: "txt" }, [
                  _vm._v("(" + _vm._s(_vm.reviews.stars[3]) + ")"),
                ])
              : _c("span", { staticClass: "txt" }, [_vm._v("(...)")]),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "bar-c" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("span", { staticClass: "bar-b" }, [
              _vm.dataLoaded
                ? _c("span", {
                    staticClass: "bar",
                    style:
                      "width:" +
                      (_vm.reviews.stars[2] / _vm.reviews.userScore) * 100 +
                      "%",
                  })
                : _c("span", {
                    staticClass: "bar",
                    staticStyle: { width: "0%" },
                  }),
            ]),
            _vm._v(" "),
            _vm.dataLoaded
              ? _c("span", { staticClass: "txt" }, [
                  _vm._v("(" + _vm._s(_vm.reviews.stars[2]) + ")"),
                ])
              : _c("span", { staticClass: "txt" }, [_vm._v("(...)")]),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "bar-c" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("span", { staticClass: "bar-b" }, [
              _vm.dataLoaded
                ? _c("span", {
                    staticClass: "bar",
                    style:
                      "width:" +
                      (_vm.reviews.stars[1] / _vm.reviews.userScore) * 100 +
                      "%",
                  })
                : _c("span", {
                    staticClass: "bar",
                    staticStyle: { width: "0%" },
                  }),
            ]),
            _vm._v(" "),
            _vm.dataLoaded
              ? _c("span", { staticClass: "txt" }, [
                  _vm._v("(" + _vm._s(_vm.reviews.stars[1]) + ")"),
                ])
              : _c("span", { staticClass: "txt" }, [_vm._v("(...)")]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "txt" }, [
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" 5"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "txt" }, [
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" 4"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "txt" }, [
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" 3"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "txt" }, [
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" 2"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "txt" }, [
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" 1"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }